import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  ImageBackground, View,
} from 'react-native';
import PendingImage from '../misc/PendingImage';
import styles from '../../styles';
import face from '../../assets/images/glyphicons-camera.png';

class PublisherIcon extends PureComponent {
  constructor(props, context) {
    super(props, context);

    console.log('PublisherIcon');
  }

  render() {
    const {
      source,
      hasImage,
      loadable,
    } = this.props;

    if (!hasImage || !source) {
      return (
        <View
          style={styles.publisherIcon.viewImageStyles}
        >
          <ImageBackground
            style={[
              styles.publisherIcon.backgroundImage,
              styles.publisherIcon.backgroundImageDefault,
            ]}
            source={face}
            resizeMode="stretch"
          />
        </View>
      );
    }

    return (
      <View
        style={styles.publisherIcon.viewImageStyles}
      >
        <PendingImage
          imageStyle={styles.publisherIcon.backgroundImage}
          activityIndicatorStyle={styles.publisherIcon.activityIndicator}
          source={source}
          loadable={loadable}
        />
      </View>
    );
  }
}

PublisherIcon.defaultProps = {
  loadable: false,
  hasImage: true,
  source: null,
};

PublisherIcon.propTypes = {
  hasImage: PropTypes.bool,
  loadable: PropTypes.bool,
  source: PropTypes.oneOfType([
    PropTypes.shape({
      uri: PropTypes.string,
      headers: PropTypes.objectOf(PropTypes.string),
    }),
    PropTypes.number,
    PropTypes.arrayOf(
      PropTypes.shape({
        uri: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        headers: PropTypes.objectOf(PropTypes.string),
      })
    ),
  ]),
};

export default PublisherIcon;
